<template>  
  <div class="modal-card modal-card--md modal-card--modern">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Oops
      </p>
     
      <a class="close-modal" aria-label="close" @click="closeModal()">
        <i class="material-icons">close</i>
      </a>
    </header>
    <section class="modal-card-body">

      <p>
        We can't recognise what company you're trying to join from your email address.
      </p>

      <p>
        If your company is already signed up, make sure you are signing in using your company email address, and ask your company admin to ensure your email domain is on their whitelist.
      </p>

      <p>
        If you don't know your company admin, or you're a new company, please contact us for the next steps.
      </p>

      <!-- <p class="large-icon">
        <span class="icon icon-alert-triangle"></span>
      </p>
       -->
    
      <div class="flexbox-center button-row">
        <button class="button button-medium button-grey button-outline" @click="closeModal()" id="close-button">
          Close
        </button>

        <!-- <a class="button button-medium button-secondary" href="mailto:rob.lundiehill@refinitiv.com?Subject=DSA%20Company%20Access">
          Contact Support
        </a> -->
      </div>
      
    </section>
  </div>
</template>

<script lang="ts">
declare var AuthBar: any;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import api from "../../api/newget"
@Component({
  components: {
  },
})
export default class NoCompany extends Vue {

  private async logout(){
     try{
      const res = await api.get("/logout");
      if (res && res.status === 200) {
        console.log("Logout successful");
        this.$store.dispatch('onLogout');
      } else {
        console.error("Logout failed", res.data.message);
      }
    }catch(e){
      console.error("Error while calling logout API on logout", e);
    }
  }

  public closeModal() {
    this.logout();
    this.$store.commit('setModal', '');
  }

}

</script>

<style scoped lang="scss">
@import '@/scss/partials/_settings.colors.scss';
  .modal-card--modern {
    p {
      max-width: 550px;
      margin-left: auto;
      margin-right: auto;
    }
  }



</style>